import React from "react";
import Slider from "react-slick";

export default function MediaSection({ data }) {
  if (!data?.items?.length) {
    return null;
  }

  const desktopSlides = Math.min(4, data.items.length);
  const sliderItems =
    data.items.length > 1 && data.items.length <= desktopSlides
      ? [...data.items, ...data.items]
      : data.items;
  const canSlide = sliderItems.length > desktopSlides;

  const settings = {
    arrows: false,
    autoplay: canSlide,
    autoplaySpeed: 3500,
    dots: canSlide,
    infinite: canSlide,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 700,
    slidesToShow: desktopSlides,
    slidesToScroll: data.items.length === 4 ? 2 : 1,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, data.items.length),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(2, data.items.length),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="media-section">
      <div className="container">
        <div className="enthusiasm-content">
          <h3 className="heading text-center">{data.title}</h3>
        </div>
        <Slider className="media-container media-slider" {...settings}>
          {sliderItems.map((item, index) => (
            <article
              className="media-card"
              key={`${item.title}-${index}`}
            >
              <div className={`card-image ${item.color}`}>
                <img src={item.image} alt={item.alt} />
              </div>
              <div className="card-content">
                <div className="title">{item.title}</div>
                <a href={item.url} target="_blank" rel="nofollow noopener noreferrer" >
                  Learn More <i className="fa-solid fa-arrow-right" />
                </a>
              </div>
            </article>
          ))}
        </Slider>
      </div>
    </section>
  );
}
